import React, { useEffect, useState } from 'react'
import './SpinLoading.scss'

const SpinLoading = (props) => {
    const { size = '48px', style } = props
    return (
        <img
            className='spin-loading'
            style={{
                ...style,
                width: size,
                height: size,
            }}
            src={require('@/assets/slices/icon_toast_loading.png')}
        />
    )
}

export default SpinLoading
